export const getTweetShareLink = (shareText: string, link: string) => {
	const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}${link ? `&url=${encodeURIComponent(link)}` : ''}`;
	return url;
};
